<script setup>
import { computed } from 'vue'

const props = defineProps({
  attemptsLeft: { type: Number, required: true },
  wrongfullyMarkedCount: { type: Number, default: 0 },
})

defineEmits(['dismiss'])

const attemptsText = computed(() => {
  if (props.attemptsLeft === 0) return 'Je hebt geen pogingen meer over.'
  if (props.attemptsLeft === 1) return 'Je hebt nog 1 poging over.'
  return `Je hebt nog ${props.attemptsLeft} pogingen over.`
})

const wrongfullyMarkedText = computed(() => {
  if (props.wrongfullyMarkedCount === 0) return null
  if (props.wrongfullyMarkedCount === 1) return '1 aangevinkt vakje is (nog) niet omgeroepen.'
  return `${props.wrongfullyMarkedCount} aangevinkte vakjes zijn (nog) niet omgeroepen.`
})
</script>

<template>
  <div class="game-overlay" role="alertdialog">
    <div class="overlay-card">
      <div class="overlay-emoji">&#128556;</div>
      <h2 class="overlay-title">Helaas, dat was geen bingo!</h2>
      <p v-if="wrongfullyMarkedText" class="overlay-text">{{ wrongfullyMarkedText }}</p>
      <p class="overlay-text">{{ attemptsText }}</p>
      <button class="cta-button" @click="$emit('dismiss')">Verder spelen</button>
    </div>
  </div>
</template>

<style scoped>
.game-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 24px;
}

.overlay-card {
  background: var(--bingo-gradient-ui);
  border-radius: 16px;
  padding: 40px 32px;
  text-align: center;
  max-width: 360px;
  width: 100%;
}

.overlay-emoji {
  font-size: 3rem;
  margin-bottom: 8px;
}

.overlay-title {
  font-family: var(--bingo-font-heading);
  text-transform: uppercase;
  color: white;
  font-size: 1.4rem;
  margin: 0 0 16px;
}

.overlay-text {
  font-family: var(--bingo-font-body);
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0 0 12px;
}

.cta-button {
  font-family: var(--bingo-font-heading);
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  color: var(--bingo-cta-text);
  background: white;
  border: none;
  border-radius: 24px;
  padding: 12px 32px;
  margin-top: 12px;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: transform 0.15s ease;
}

.cta-button:hover {
  transform: scale(1.03);
}
</style>
